// extracted by mini-css-extract-plugin
module.exports = {"price":"fv-z","onSale":"gv-z"};